import * as React from 'react';
import { Image, StyleSheet, Text, Pressable } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { Map } from "./Map";
import { LocationDetails } from "./LocationDetails";
import { ProductDetails } from "./ProductDetails";
import * as AppConstants from "../context/AppConstants";
import * as AppUtilities from "../context/AppUtilities";
import { useSelector, useDispatch } from 'react-redux';
import { FilterSlider } from '../components/FilterSlider';
import { HeaderLeft } from '../components/HeaderLeft';
import { Filter } from "./Filter";

const Stack = createNativeStackNavigator();

const styles = StyleSheet.create({
  mainImage: {
    width: 224,
    height: 38,
  },
  appleStoreImage: {
    width: 102,
    height: 30,
    marginRight: 20,
  },
  androidStoreImage: {
    width: 101,
    height: 30,
    marginRight: 20,
  },
});

export function MapStack() {
  const showHeader = useSelector((state) => state.showHeader);
  const showFilterSlider = useSelector((state) => state.showFilterSlider);

  let mainImage = <Image source={require('../../assets/logo.png')} style={styles.mainImage} />;
  if (AppUtilities.isWeb()) {
    mainImage = <a href="/">{mainImage}</a>;
  }

  return (
    <Stack.Navigator
      screenOptions={({ navigation, route }) => ({
        headerRight: AppUtilities.getHeaderRight(navigation),
        headerTitle: (props) => <></>,
        detachPreviousScreen: false,
        animationEnabled: false,
        headerShown: showHeader,
        headerBackVisible: false,
        headerBackTitleVisible: false,
      })}
    >
      <Stack.Screen
        name={AppConstants.SCREENS.MAP}
        component={Map}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} forceNoBackButton={true}>{mainImage}</HeaderLeft>,
          headerRight: () => (
            AppUtilities.isWeb() ?
                AppUtilities.isWebiOS() ?
                    <Pressable onPress={() => AppUtilities.openLink(AppConstants.APPLE_STORE_LINK)}>
                      <Image source={require('../../assets/appstore30.png')} style={styles.appleStoreImage} />
                    </Pressable>
                  :
                    AppUtilities.isWebAndroid() ?
                        <Pressable onPress={() => AppUtilities.openLink(AppConstants.ANDROID_STORE_LINK)}>
                          <Image source={require('../../assets/playstore30.png')} style={styles.androidStoreImage} />
                        </Pressable>
                      :
                        null
              :
                null
          ),
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.LOCATION_DETAILS}
        component={LocationDetails}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Loading..." />,
          headerRight: () => showFilterSlider ? <FilterSlider vertical={false} /> : null,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.PRODUCER_DETAILS}
        component={LocationDetails}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Loading..." />,
          headerRight: () => showFilterSlider ? <FilterSlider vertical={false} /> : null,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.PRODUCT_DETAILS}
        component={ProductDetails}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Loading..." noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.FILTER_MAP}
        component={Filter}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Filter" noFiltersRight={true} />,
        })}
      />
    </Stack.Navigator>
  );
}
